import { Tooltip, Typography } from "antd";
import { ColumnType } from "antd/es/table";
import { trimTrailingZeros } from "utils";
import { TokenDepositWithId } from "services/walletTokens";

import styles from "./returnButton.module.css";
import { ItemInfoType } from "interfaces";

export const getColumns = (currency: string | null): Array<ColumnType<TokenDepositWithId>> => {
  return [
    {
      dataIndex: "from",
      key: "from",
      title: "Адрес кошелька",
      width: 380,
      className: `text-clamp-ellipsis ${styles.sender}`,
    },
    {
      dataIndex: "amount",
      key: "amount",
      width: 180,
      title: "Сумма пополнения",
      align: "right",
      className: `text-clamp-ellipsis ${styles.amount}`,
      render: (_: any, record: TokenDepositWithId) => {
        return (
          <Tooltip title={`${record.amount} ${currency || ""}`}>
            {trimTrailingZeros(record.amount)} {currency || ""}
          </Tooltip>
        );
      },
    },
  ].filter((c) => !!c) as ColumnType<TokenDepositWithId>[];
};

export const getConfirmColumns = (balance: number, wallet: string): Array<ItemInfoType> => {
  return [
    {
      label: "Возврат токенов",
      text: <Typography.Text strong>{balance}</Typography.Text>,
      width: 24,
    },
    {
      label: "На адрес отправителя",
      text: <Typography.Text strong>{wallet}</Typography.Text>,
      width: 24,
    },
  ].filter((c) => !!c) as ItemInfoType[];
};
